/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-24 18:54:55
 * @LastEditTime: 2022-01-29 16:09:04
 * @LastEditors: zhao - 🍉
 * @Description: 管家详情
 * @FilePath: /zhzj-admin/src/page/HouseKeep/detail.jsx
 */



import { Button, Empty, Modal, Table, message, Popconfirm, Divider } from 'antd';
import React, { useState } from 'react'
import { useRef } from 'react';
import { authenticationStatus } from '../../axios/dictionaries';
import AuthButton from '../../components/AuthButton/AuthButton';

import { CustomCol, CustomRow } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import FileView from '../../components/FileView';
import ModalScrollContainer from '../../components/ModalScrollContainer';
import { fetchHouseKeepGet, fetchHouseKeepSendSignSms } from '../../services/housekeep';
import { findDict, formatTime } from '../../utils';
import MerchantDetail from "./components/MerchantInfo";


const HouseKeepDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const MerchantDetailRef = useRef()
    const open = (id) => {
        setVisible(true)
        postGet(id)
    }
    const close = () => {
        setVisible(false)
    }

    const postGet = (id) => {
        setLoading(true)
        fetchHouseKeepGet({id}).then(res => {
            setDetailData(res)
        }).finally(() => {
            setLoading(false)
        })
    }
    const handleSendSms =(id) => {
        fetchHouseKeepSendSignSms({id}).then(() => {
            message.success('发送成功')
        })
    }

    const merchantUserInfoColumns = [
        { title: '商户名称', dataIndex: 'merchantName', },
        { title: '签约状态', dataIndex: 'signStatus', render: (text, record) => {
            return <React.Fragment>
                <span style={{ marginRight: 6 }}>{text === 2 ? '已签' : '未签'}</span>
                {record.attachList?record.attachList.map(e => <a target={"_blank"} href={e.fileUrl} style={{ marginLeft: 4 }}>{e.fileName}</a>):null}
            </React.Fragment>
        }},
        { title: '上上签电子合同id', dataIndex: 'electronicContractId', },
        { title: '合同签约日期', dataIndex: 'signTime', render: formatTime},
        { title: '管家已签', dataIndex: 'housekeeperSigned', render: (text) => text ? '是' : '否'},
        { title: '商户已签', dataIndex: 'merchantSigned', render: (text) => text ? '是' : '否'},
        // { title: '电子合同合同过期日期', dataIndex: 'electronicContractExpirationTime', render: formatTime},
        { title: '合同创建时间', dataIndex: 'electronicContractGenerationTime', render: formatTime},
        { title: '操作', dataIndex: 'actions', width: 100, fixed: 'right', render: (text, record) => {
            
      
            
            return (
                <React.Fragment>
                    <a onClick={() => MerchantDetailRef.current.open(record.id)}>详情</a>
                    <Divider type="vertical" />
                    {
                        // 已签约 不需要发送签约短信
                        record.signStatus !== 2 && (
                            <AuthButton authkey="b-2-2">
                                <Popconfirm title="确认发送吗?" onConfirm={() => handleSendSms(record.id)}>
                                    <a >发送签约短信</a>
                                </Popconfirm>
                            </AuthButton>
                        )
                    }
                </React.Fragment>
            )
        } }
        // { title: '复合对象', dataIndex: 'merchantBuildingInfoList', render: (text) => {}},
        // { title: '复合对象', dataIndex: 'attachList', render: (text) => {}},
    ]
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="管家详情" 
            width={950} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <DetailTitle title="基础信息" />
                    <CustomRow>
                        <CustomCol label="证件姓名">
                            <span style={{ paddingLeft:6 }}>{detailData.credentialName}</span>
                        </CustomCol>
                    
                        <CustomCol label="证件号码">
                            <span style={{ paddingLeft:6 }}>{detailData.credentialNumber}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="人脸识别">
                            <span style={{ paddingLeft:6 }}>{detailData.faceDetected ? '已认证': '未认证'}</span>
                        </CustomCol>
                    
                        <CustomCol label="人脸认证方式">
                            <span style={{ paddingLeft:6 }}>{findDict(authenticationStatus,detailData.faceDetectedMode).title}</span>
                        </CustomCol>
                    
                        <CustomCol label="人脸识别时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.faceDetectedTime)}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="实名认证">
                            <span style={{ paddingLeft:6 }}>{detailData.realNameIdentified ? '已认证' : '未认证'}</span>
                        </CustomCol>
                        <CustomCol label="实名认证方式">
                            <span style={{ paddingLeft:6 }}>{findDict(authenticationStatus, detailData.realNameMode).title}</span>
                        </CustomCol>
                        <CustomCol label="实名认证时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.nameIdentifiedTime)}</span>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="人脸认证照片" />
                    {detailData.attachList && detailData.attachList.length ? 
                        detailData.attachList.map(e => {
                            return (
                                <FileView
                                    src={e.fileUrl} 
                                    text={e.fileName}
                                    onClick={(() => window.open(e.fileUrl))} 
                                />
                            )
                        })
                        :
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    }

                    <DetailTitle title="商户用户数据" />
                    <Table 
                        columns={merchantUserInfoColumns}
                        dataSource={detailData.merchantUserInfoList}
                        scroll={{ x: 2000 }}
                    />
                </div>
            </ModalScrollContainer>
            <MerchantDetail ref={MerchantDetailRef} />
        </Modal>
    )
}

export default HouseKeepDetail


// WEBPACK FOOTER //
// ./src/page/HouseKeep/detail.jsx